/*
 * The two signed-out screens: sign in (/) and "Become a partner" (/apply).
 * Not worth a router. /apply is a real path so it can be linked from
 * wealthoak.ai; nginx already serves index.html for any path.
 */

import { useEffect, useState } from "react";

export const APPLY_PATH = "/apply";

export function go(path: string) {
  if (window.location.pathname === path) return;
  window.history.pushState(null, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo(0, 0);
}

export function usePath(): string {
  const [path, setPath] = useState(() => window.location.pathname);
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return path;
}
